import { render, staticRenderFns } from "./multilayer-donut-chart.component.vue?vue&type=template&id=6c37a509&scoped=true"
import script from "./multilayer-donut-chart.component.ts?vue&type=script&lang=ts&external"
export * from "./multilayer-donut-chart.component.ts?vue&type=script&lang=ts&external"
import style0 from "./multilayer-donut-chart.component.vue?vue&type=style&index=0&id=6c37a509&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c37a509",
  null
  
)

export default component.exports